export default "__VITE_ASSET__b5a4fe14__"